<div class="success-container">
  <div class="checkmark-circle">
    <div class="background"></div>
    <div class="checkmark"></div>
  </div>
  <h3>{{ 'settings.billing.success.paymentSuccess' | translate }}</h3>
  <span>{{ 'settings.billing.success.thankYouPayment' | translate }}</span>
  <button mat-raised-button color="primary" type="button" (click)="backToBilling()">
    {{ 'settings.billing.success.close' | translate }}
  </button>
</div>
